import { SUBACTION_STATE } from './constants';

/**
 * Converts a date in a string or epoch time into MMM DD, YYYY
 * @param {String|Integer} time Either a human readable date or epoch time
 * @param {Boolean} epoch Bool to convert the epoch or not.
 * @returns
 */
export const convertToLocalDate = (
  time,
  epoch = true,
  locales?: string | string[]
) => {
  if (epoch) {
    time *= 1000;
  }
  return new Date(time).toLocaleDateString(locales, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

/**
 * Converts a date in a string or epoch time into YYYY-MM-DD
 * WARNING: Not Tested
 * @param {String|Integer} time Either a human readable date or epoch time
 * @param {Boolean} epoch Bool to convert the epoch or not.
 * @returns
 */
export const convertToDbDate = (time, epoch = true) => {
  if (epoch) {
    time *= 1000;
  }
  const d = new Date(time);
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  const year = d.getFullYear().toString().padStart(4, '0');

  return `${year}-${month}-${day}`;
};

export const getTwoDigitTimeNow = () =>
  new Date().toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });

/**
 * Adds '...' to the end of a string and returns its first N chars, if its too long.
 */
export const truncateIfLong = (text) => {
  const maxChars = 17;
  return text.length <= maxChars ? text : `${text.substring(0, maxChars)}...`;
};

export const isDone = (task) =>
  parseInt(task.state) === SUBACTION_STATE.STATE_DONE;

export const numberFromString = (unknownValue) => {
  // if (unknownValue === 'null') return 0;
  const numericVal = parseInt(unknownValue);
  return typeof numericVal === 'number' && !Number.isNaN(numericVal)
    ? numericVal
    : 0;
};

/**
 * In some cases, a date may be stored as '0' (e.g subaction start / end dates)
 * We want to return a string if they're '0' (e.g 'No date'), and otherwise, format them
 * by a formatter function.
 *
 * That's what this function does
 * @param date Raw value of a date that may be the string '0'
 * @param zeroString String to return if the date is '0' - e.g 'No date'
 * @param formatterFunc a function that takes the date (if not 0) and returns a formatted representation
 *                  (e.g Dec 2021)
 *
 * @return zeroString (if date = '0') or output from formatterFunc
 */
export const formatZeroDate = (date, zeroString, formatterFunc) =>
  date === '0' ? zeroString : formatterFunc(date);

export const dateToSeconds = (jsDate) =>
  jsDate !== null && typeof jsDate === 'object'
    ? (jsDate.getTime() / 1000).toString()
    : '0';

export const toggleBodyScrollLock = (isEnabled: boolean) => {
  const method = isEnabled ? 'add' : 'remove';
  document?.body?.classList?.[method]('body-scroll-lock');
};
